import {maintenance, railway_safety} from './images'
const servicesData = [
    {
      title: "Railway Safety Permit Compliance",
      image: railway_safety,
      description: [
        "Implementing a Safety Management System (SMS) and preparing a Safety Management System Report (SMSR).",
        "Handling Railway Safety Permit Applications on behalf of clients.",
        "Managing and maintaining the SMS to ensure regulatory compliance.",
        "Developing an Annual Safety Improvement Plan (ASIP).",
        "Negotiating siding interface agreements with other network owners and facilitating approvals for interface management.",
        "Comprehensive risk assessment, effective management, and proactive mitigation of all aspects related to railway operations.",
        "Ensuring that maintenance contractors adhere to safety procedures, regulations, and Railway Safety Regulator (RSR) standards.",
        "Monitoring compliance with environmental, health, and safety regulations and implementing corrective actions when necessary."
      ]
    },
    {
      title: "Comprehensive Maintenance Services",
      image: maintenance,
      description: [
        "Overseeing siding railway operation and maintenance.",
        "Establish and execute engineering protocols and guidelines aimed at enhancing the operational efficiency and productivity of railway sidings.",
        "Collaborating with clients to draft, review, and finalize maintenance contracts.",
        "Implementing whole-life asset management to align budgets for maintenance contracts.",
        "Overseeing siding maintenance budgets, ensuring adherence to contract terms, and optimizing maintenance services.",
        "Evaluating contractors’ performance and devising strategies to mitigate operational disruptions.",
        "Effectively executing, monitoring, and renewing or renegotiating contracts as needed, including outsourcing advisory.",
        "Maintenance strategy formulation, implementation and creating strategies to reduce operational disruptions.",
        "Identifying improvements and cost efficiencies in maintenance contract management.",
        "Ensure compliance with all safety and regulatory requirements, and maintain a safe working environment.",
        "Compiling contract performance reports, financial status, and compliance."
      ]
    },
    {
      title: "Railway Infrastructure Upgrades",

      description: [
        "Remodelling/Modernisation of Railway Yards and Railway siding ensuring compliance with RSR standards.",
        "Conceptual design to actual construction and technical delivery of multidisciplinary rail projects."
      ]
    },
    {
      title: "Level Crossing and Railway Wayleaves Management",

      description: [
        "Overseeing the design, submission, and approval process by Railway authorities.",
        "Providing construction supervision, creating as-built drawings, and managing handover."
      ]
    },
    {
      title: "Advisory/Consulting Services",

      description: [
        "Handling all aspects of railway siding projects, from feasibility studies to commissioning.",
        "Offering advisory and consulting services related to rail-related matters.",
        "Value engineering, collaborative peer reviews and design evaluations."
      ]
    },
    {
      title: "Railway Project Management",

      description: [
        "Coordinating various aspects of railway projects, including planning, execution, monitoring, and control, while also serving as the principal agent and providing client representative support.",
        "Effective contract management, change control, project oversight, procurement management, budget administration, scheduling services, construction supervision, and quality control."
      ]
    },
    {
      title: "Deployment of Professionals",

      description: [
        "Providing skilled project managers and technical experts for railway projects, including Project Managers, Engineers, Coordinators, and Track Masters."
      ]
    }
  ];

  export default servicesData;